(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/match-init-box/assets/javascripts/models/init-box.js') >= 0) return;  svs.modules.push('/components/sport/match-init-box/assets/javascripts/models/init-box.js'); 'use strict';

(function(Backbone, _, svs) {
  function isDrawLive(match, regCloseTime) {
    return (
      Date.parse(regCloseTime) &&
      new Date(regCloseTime).getTime() < Date.now() &&
      (!match || match.statusId > 0)
    );
  }

  svs.sport.matchInitBox.models.InitBox = Backbone.Model.extend({
    isDrawLive: isDrawLive,

    defaults: function() {
      return {
        initObject: ''
      };
    },
    createInitBox: function(
      match,
      closeTime,
      regCloseTime,
      isLive,
      sport,
      date,
      liveDraw,
      media,
      hideMatchInfo,
      showStartText
    ) {
      var sportId = true;
      if (date === undefined) {
        date = true;
      }
      if (liveDraw) {
        date = false;
      }
      if (closeTime) {
        closeTime = regCloseTime;
      } else {
        closeTime = false;
      }

      if (sport) {
        sportId = sport.id;
      }

      if (!match) {
        this.set(
          'initObject',
          {
            opt: {
              tv: media, 
              live: isLive, 
              spelstopp: closeTime, 
              date: false,
              startedLiveDraw: liveDraw
            },
            startTime: false,
            status: false, 
            matchId: false,
            sport: sportId,
            hideMatchInfo: hideMatchInfo,
            showStartText: showStartText
          },
          { silent: true }
        );
      } else {
        this.set(
          'initObject',
          {
            opt: {
              tv: media, 
              live: isLive, 
              spelstopp: closeTime, 
              date: date,
              startedLiveDraw: liveDraw
            },
            startTime: match.matchStart,
            status: {
              id: match.statusId,
              realTime: match.statusTime
            }, 
            matchId: match.matchId,
            sport: sportId,
            hideMatchInfo: hideMatchInfo,
            showStartText: showStartText
          },
          { silent: true }
        );
      }
    }
  });

  svs.sport.matchInitBox.isDrawLive = isDrawLive;
})(Backbone, _, svs);

 })(window);